import { createContext, useContext } from 'react';
import type { ReactChildren } from '@gokrew/models/ui.types';
import { useTimesheetPolicy } from '@/hooks/useTimesheet';
import { useEmployeePortalAuth } from './EmployeeAuthContext';

interface TimesheetPolicyContextType {
  requestFlowEnabled: boolean | undefined;
}

const TimesheetPolicyContext = createContext<
  TimesheetPolicyContextType | undefined
>(undefined);

export const TimesheetPolicyProvider = ({ children }: ReactChildren) => {
  const { token } = useEmployeePortalAuth();
  const { data } = useTimesheetPolicy({ enabled: !!token });

  return (
    <TimesheetPolicyContext.Provider
      value={{ requestFlowEnabled: data?.data?.requestFlowEnabled }}
    >
      {children}
    </TimesheetPolicyContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTimesheetPolicyContext = () => {
  const context = useContext(TimesheetPolicyContext);
  if (!context) {
    throw new Error(
      'useTimesheetPolicyContext must be used within a TimesheetPolicyProvider'
    );
  }
  return context;
};
